import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_USER_UNSEEN_EVENTS } from '@/api/endpoints';
import { USER_UNSEEN_EVENTS_QUERY_KEY } from '@/api/queryKeys';
import type { UnseenEventsResponse } from '@/types/user';
import { unwrapAxiosResponse } from '@/utils/axios';

interface Params {
  shouldRefetchOnMount?: boolean;
}

export const useUnseenEvents = ({ shouldRefetchOnMount = true }: Params = {}) =>
  useQuery<UnseenEventsResponse>({
    queryKey: USER_UNSEEN_EVENTS_QUERY_KEY,
    queryFn: () =>
      apiClient
        .get<UnseenEventsResponse>(API_USER_UNSEEN_EVENTS)
        .then(unwrapAxiosResponse),
    refetchOnMount: shouldRefetchOnMount,
  });
